import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ProductSkeleton } from './ProductSkeleton'
import AllGiftCard from '../AllGiftCard'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getAllProducts } from '../../../apiCalls/urls/urlFunction';
import ProductPaginate from './ProductPaginate'

const categoryUrl = (title) => {
    const url = title?.toLowerCase().replace(/\s+/g, "-");
    return url?.replace(/[^a-z0-9-]/g, "");
};

function ProductList() {
    const [allProduct, setAllProduct] = useState([])
    const [loading, setLoading] = useState(true);
    const [totalPage, setTotalPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState([])
    const navbarCategory = useSelector((state) => state.Category.allData);
    const products = useSelector((state) => state.AllProducts.allData)

    let location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const categoryParam = searchParams.get('category');

        if (categoryParam) {
            const selectedCategories = categoryParam.split(' ');
            const categoryIdList = findCategoryId(selectedCategories);
            if (navbarCategory.length > 0) {
                setSelectedCategory(categoryIdList);
                fetchProducts(categoryIdList, 1);
            }
        } else {
            if (products?.length > 0) {
                setAllProduct(products.slice(0, 20));
                setTotalPage(Math.ceil(products?.length / 20));
                setLoading(false);
            }
        }

    }, [location.search, navbarCategory, products]);

    const handlePageChange = (event, value) => {
        fetchProducts(selectedCategory, value);
    };

    return (

        <Box sx={{
            minHeight: "500px"
        }}>

            <Box
                sx={{
                    display: "grid",
                    gap: "8px",
                    gridTemplateColumns: {
                        md: "repeat(auto-fill, minmax(180px, 1fr))",
                        lg: "repeat(auto-fill, minmax(230px, 1fr))",
                        xl: "repeat(auto-fill, minmax(230px, 1fr))",
                    },
                    placeItems: "center"
                }}
            >
                {/* Conditionally render Skeleton or actual cards based on loading state */}
                {loading ? (Array.from({ length: 20 }).map((_, index) => (
                    <ProductSkeleton key={`products-card-${index * 1}`} />
                ))) :
                    (allProduct?.map((singleProductData) => (
                        <AllGiftCard singleProductData={singleProductData}
                            key={singleProductData?.id} />)))}
            </Box>

            <ProductPaginate
                totalPage={totalPage}
                handlePageChange={handlePageChange}
            />

        </Box>
    )

    function findCategoryId(selectedCategories) {
        const categorySelected = navbarCategory?.filter((item) =>
            selectedCategories.includes(categoryUrl(item.title))
        );
        const categoryId = categorySelected?.map((item) => item.id);
        return categoryId;
    }

    async function fetchProducts(selectedCategories = [], page = 1) {
        setLoading(true);
        let response = await getAllProducts({
            search: '',
            filterBy: "title",
            selectedCategories: [...selectedCategories],
            pagination: {
                sortBy: "id",
                descending: false,
                page: page,
                rowsPerPage: 20,
                rowsNumber: 0,
            },
        });

        if (response.status) {
            setLoading(false);
            setAllProduct(response?.data?.data);
            setTotalPage(Math.ceil(response?.data?.pagination?.total / 20));
        } else {
            console.error(response.error);
        }
    }
}

export default React.memo(ProductList);